import Repository from "./Repository";

import { httpClient } from "@/shared/services";

const resource = "/projects";

const fetchProjects = params => {
  return httpClient.get(resource, { params }).then(res => res.data);
};

const fetchProject = uuid => {
  const url = `${resource}/${uuid}`;
  return httpClient.get(url).then(res => res.data);
};

const updateProject = (uuid, payload) => {
  const url = `${resource}/${uuid}`;
  return httpClient.put(url, payload).then(res => res.data);
};

const createProject = payload => {
  return httpClient.post(resource, payload).then(res => res.data);
};

const fetchMedia = (uuid, media_uuid) => {
  const url = `${resource}/${uuid}/media/${media_uuid}`;
  return httpClient.get(url).then(res => res.data);
};

const deleteMedia = (uuid, media_uuid) => {
  const url = `${resource}/${uuid}/media/${media_uuid}`;
  return httpClient.delete(url).then(res => res.data);
};

const fetchImageMedia = (uuid, media_uuid) => {
  const url = `${resource}/${uuid}/media/${media_uuid}/image`;
  return httpClient.get(url).then(res => res.data);
};

const fetchSoftdeletedMedia = (uuid, media_uuid) => {
  const url = `${resource}/${uuid}/media/${media_uuid}?trashed`;
  return httpClient.get(url).then(res => res.data);
};

const createSketch = (uuid, media_uuid, payload) => {
  const url = `${resource}/${uuid}/media/${media_uuid}`;
  return httpClient.post(url, payload).then(res => res.data);
};

const updateSketch = (uuid, media_uuid, payload) => {
  const url = `${resource}/${uuid}/media/${media_uuid}`;
  return httpClient.post(url, payload).then(res => res.data);
};

const createImageMedia = (uuid, media_uuid, payload) => {
  const url = `${resource}/${uuid}/media/${media_uuid}/image`;
  return httpClient.post(url, payload).then(res => res.data);
};

export {
  fetchProjects,
  fetchProject,
  deleteMedia,
  fetchImageMedia,
  updateProject,
  createProject,
  fetchMedia,
  fetchSoftdeletedMedia,
  createSketch,
  updateSketch,
  createImageMedia
};

export default {
  async get() {
    return httpClient.get(resource).then(res => res.data);
    // return Repository.get(`${resource}`);
  },

  async getProject(projectUuid) {
    return Repository.get(`${resource}/${projectUuid}`);
  },

  async createProject(payload) {
    return Repository.post(`${resource}`, payload);
  },

  async updateProject(projectUuid, payload) {
    return Repository.put(`${resource}/${projectUuid}`, payload);
  },

  /**
   * Medias
   */

  /**
   * Get a media from server
   *
   * @param {String} project_uuid Project uuid
   * @param {String} media_uuid Media uuid
   */
  getMedia(project_uuid, media_uuid) {
    return Repository.get(`${resource}/${project_uuid}/media/${media_uuid}`);
  },

  getTrashedMedia(project_uuid, media_uuid) {
    return Repository.get(
      `${resource}/${project_uuid}/media/${media_uuid}?trashed`
    );
  },

  /**
   * Get a media image from server
   *
   * @param {String} project_uuid Project uuid
   * @param {String} media_uuid Media uuid
   */
  getMediaImage(project_uuid, media_uuid) {
    return Repository.get(
      `${resource}/${project_uuid}/media/${media_uuid}/image`
    );
  },

  /**
   * Create a sketch media on server
   *
   * @param {String} project_uuid Project uuid
   * @param {String} media_uuid Media uuid
   * @param {Object} payload Payload
   */
  createSketchMedia(project_uuid, media_uuid, payload) {
    return Repository.post(
      `${resource}/${project_uuid}/media/${media_uuid}`,
      payload
    );
  },

  /**
   * Update a sketch media on server
   *
   * @param {String} project_uuid Project uuid
   * @param {String} media_uuid Media uuid
   * @param {Object} payload Payload
   */
  updateSketchMedia(project_uuid, media_uuid, payload) {
    return Repository.put(
      `${resource}/${project_uuid}/media/${media_uuid}`,
      payload
    );
  },

  /**
   * Create a image media on server
   *
   * @param {String} project_uuid Project uuid
   * @param {String} media_uuid Media uuid
   * @param {Object} payload Payload
   */
  createImageMedia(project_uuid, media_uuid, payload) {
    return Repository.post(
      `${resource}/${project_uuid}/media/${media_uuid}/image`,
      payload
    );
  },

  deleteProjectMedia(project_uuid, media_uuid) {
    return Repository.delete(`${resource}/${project_uuid}/media/${media_uuid}`);
  },

  createProjectMediaImage(project_uuid, media_uuid, payload) {
    return Repository.post(
      `${resource}/${project_uuid}/media/${media_uuid}/image`,
      payload
    );
  },

  setDelivery(project_uuid) {
    return Repository.put(`${resource}/${project_uuid}/delivery`);
  }
};
